(function() {
  if (window.productDetailsInit) {
    return;
  }

  window.productDetailsInit = true;

  function addGlobalEventListener(type, selector, cb, options, parent = document) {
    parent.addEventListener(type, e => { 
      if (e.target.matches(selector)) {
        e.preventDefault();
        cb(e.target);
      }
      else {
        let el = e.target.closest(selector);

        if (el) {
          e.preventDefault();
          cb(el);
        }
      }
    }, options);
  }

  function qs(selector, parent = document) {
    return parent.querySelector(selector);
  }

  function qsa(selector, parent = document) {
    return [...parent.querySelectorAll(selector)];
  }

  function getProduct(e) {
    return e.closest('.js-product-details');
  }

  addGlobalEventListener('click', '.js-add-to-bag', showModal);
  function showModal(e) {
    sessionStorage.setItem('collection-index', $(e).closest('.collection-products-tile').index());
    let product = qs(`${e.hash} .js-product-details`);
    let parent = qs('.js-product-details__info', product);

    product.style.display = 'flex';
    document.body.style.top = '-' + window.scrollY + 'px';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';

    dataLayer.push({
      event: 'Add_to_bag_quick_buy',
      itemName: parent.dataset.title,
    });
  }

  addGlobalEventListener('click', '.js-product-details__volume-item', changeVolume);
  function changeVolume(volume) {
    let product = getProduct(volume);
    let parent = qs('.js-product-details__info', product);
    let volumes = qsa('.js-product-details__volume-item', product);
    let tinContainer = qs('.js-product-details__tin-options', product);
    let productPrice = qs('.js-product-details__price', product);
    let addtoCartGroup = qsa('.js-product-details__button', product);
    //let addtoCartGroupDiv = qs('.product-details__buttons_discover', product);
    

    volumes.forEach((v) => {
      v.classList.remove('product-details__volume-item--active');
    });

    volume.classList.add('product-details__volume-item--active');
    productPrice.innerHTML = volume.dataset.variantPrice
    
    parent.dataset.cartQuantity = volume.dataset.cartQuantity;
    parent.dataset.availableQuantity = volume.dataset.availableQuantity;

    console.log(addtoCartGroup);

    if(parent.dataset.availableQuantity > 0)
    { 
      addtoCartGroup.forEach((b) => {
        b.classList.remove('product-details__buttons--hidden');
      });
      // addtoCartGroupDiv.classList.remove('product-details__buttons_discover--adjusted');
    }
    else {
      addtoCartGroup.forEach((b) => {
        b.classList.add('product-details__buttons--hidden');
      });
      // addtoCartGroupDiv.classList.add('product-details__buttons_discover--adjusted');
    }

    if (!product.dataset.isModal) {
      window.history.pushState({}, document.title, window.location.pathname + '?variant=' + volume.dataset.id);
    }

    if (volume.dataset.tinOption === 'true') {
      tinContainer.classList.remove('product-details__shipping--hidden');
    }
    else {
      tinContainer.classList.add('product-details__shipping--hidden');
    }
  }

  addGlobalEventListener('click', '.js-product-details__quantity-minus', decrementQuantity);
  function decrementQuantity(e) {
    let product = getProduct(e);
    let quantity = qs('.js-product-details__quantity-value', product);
    let error =  qs('.js-product-details__error', product);

    let value = +quantity.innerHTML;

    if (value > 1) {
      quantity.innerHTML = (value - 1);
      error.style.display = 'none';
      error.innerHTML = '';
    }
  }

  addGlobalEventListener('click', '.js-product-details__quantity-plus', incrementQuantity);
  function incrementQuantity(e) {
    let product = getProduct(e);
    let quantity = qs('.js-product-details__quantity-value', product);
    let maxQuantity = qs('.js-product-details__info', product).dataset.maxQuantity;
    let limit = maxQuantity !== '' ? parseInt(maxQuantity, 10) : 5;
    let errorMsg = qs('.js-product-details__error', product).dataset.error;
    let error =  qs('.js-product-details__error', product);

    let value = +quantity.innerHTML;
    
    if (value < limit) {
      quantity.innerHTML = (value + 1);
    } else {
      error.style.display = 'block';
      error.innerHTML = errorMsg;
    }
  }

  addGlobalEventListener('click', '.js-product-details__button', addToCart);
  function addToCart(e) {
    let product = getProduct(e);
    let info = qs('.js-product-details__info', product);
    let parent = qs('.js-product-details__info', product);
    let cartInitial = qs('.js-product-details__info', product);
    let cartQuantity = cartInitial.dataset.cartQuantity || '0';
    let quantity = qs('.js-product-details__quantity-value', product).innerHTML;
    let error = qs('.js-product-details__error', product);
    let errorMsg = qs('.js-product-details__error', product).dataset.error;
    let activeVariant = qs('.product-details__volume-item--active', product);
    let variant = qs('.product-details__volume-item--active', product);
    let variants = qsa('.js-product-details__volume-item', product);
    let maxQuantity = qs('.js-product-details__info', product).dataset.maxQuantity;
    let limit = maxQuantity !== '' ? parseInt(maxQuantity, 10) : 5;

    let tin = qs('.product-details__tin-label--active', product);
    let tinSwitch = qs('.js-product-details__tin-label', product);

    if (parseInt(cartQuantity, 10) + parseInt(quantity, 10) <= limit) {
      let body = { 
        items: [ 
          {
            id: variant.dataset.id,
            quantity: quantity
          }
        ]
      };

      if(tinSwitch) {
        if (variant.dataset.tinOption === 'true') {
          if (
            tinSwitch.classList.contains('product-details__tin-label--active')
          ) {
            body.items[0]['properties'] = { OPT: 'TIN NOT INCLUDED' };
          } else {
            body.items[0]['properties'] = { OPT: 'TIN INCLUDED' };
          }
        }
      }


      fetch(`${window.Shopify.routes.root}cart/add.js`, { 
        method: 'POST', 
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(function(res) {
        return res.json();
      })
      .then(function(res) {
        if (res.message === 'Cart Error') {
          error.style.display = 'block';
          error.innerHTML = res.description;
        } else {
          parent.dataset.cartQuantity = parseInt(cartQuantity, 10) + parseInt(quantity, 10);
          variants.forEach(function(v) {
            if (variant === v.dataset.id) {
              activeVariant.dataset.cartQuantity = parseInt(cartQuantity, 10) + parseInt(quantity, 10);
            }
          })
          error.style.display = 'none';
          error.innerHTML = '';

          if (product.dataset.isModal) {
            closeModal(e);
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        } 
      });
    } else {
        error.style.display = 'block';
        error.innerHTML = errorMsg;
    }

  }
  addGlobalEventListener('click', '.js-add-to-bag-quick', function(e){    
    let variant_id = e.dataset.variantId;
    let tinSwitch = qs(`#js-product-details__tin-label__${variant_id}`);
    let body = {
      items: [
        {
          id: variant_id,
          quantity: 1,
        },
      ],
    };
    if (e.dataset.tinOption === 'true') {
      if (
        tinSwitch.classList.contains('product-details__tin-label--active')
      ) {
        body.items[0]['properties'] = { OPT: 'TIN NOT INCLUDED' };
      } else {
        body.items[0]['properties'] = { OPT: 'TIN INCLUDED' };
      }
    }
    
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (res) {
        if (res.message !== 'Cart Error') {
          
          let item_name = res.items[0].product_title;
          dataLayer.push({
            event: 'Add_to_bag_quick_buy',
            itemName: item_name,
          });
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }
      });
  });


  addGlobalEventListener('click', '.js-product-details__close', closeModal);
  function closeModal(e) {
    let product = getProduct(e);
    product.style.display = 'none';
    document.body.style.overflow = '';
    document.body.style.position = '';
    window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
    document.body.style.top = '';
  }

  addGlobalEventListener('click', '.js-product-details__tin-label', toggleTin);
  function toggleTin(e) {
    let product = null;
    if (window.location.href.indexOf("collections") > -1) {
      product = e;
    }
    else{
      product = getProduct(e); 
    }    
    
    let label = qs('.js-product-details__tin-label-text', e);

    e.classList.toggle('product-details__tin-label--active');

    if (e.classList.contains('product-details__tin-label--active')) {
      if(label) label.innerHTML = "I DON'T WANT A TIN";
    }
    else {
      if(label) label.innerHTML = "I DO WANT A TIN";
    }
  } 

})();
